module.exports = __webpack_public_path__ + "img/notifications.0e48b084.svg";